import { css } from "@emotion/react";
import { typography } from "aviary-tokens";

import { colors, dimensions } from "@styles";

export const nav = css`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0 10rem;
  padding-top: 1.68rem;
  flex-direction: column;

  @media only screen and (max-width: ${dimensions.phoneLargeMax}) {
    margin: 0;
  }
`;

export const ul = css`
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: flex-start;
  width: 100%;
`;

export const li = css`
  padding: 0.5rem 2rem;
  width: 100%;
  a {
    padding: 0;
  }
`;

export const buttonUl = css`
  padding-right: 2rem;
  padding-left: 2rem;
  width: 100%;
`;

export const buttonLi = css`
  padding-bottom: 2rem;
  border-top: 1px solid #e4e9ed;
`;

export const navContainer = css`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const navLink = css`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  color: ${colors.grey.darkFamily.dark};
  font-weight: ${typography.weightSemiBold};
  height: 80%;

  svg path {
    fill: ${colors.grey.darkFamily.dark};
  }

  &:hover,
  &:focus {
    color: ${colors.green.base};
    path {
      fill: ${colors.green.base};
    }
  }
`;

export const homeLink = css`
  display: inline-flex;
  height: 100%;
  align-items: center;
  margin-right: 2.8125rem;
`;

export const navLogo = css`
  display: block;
  height: 1.25rem;
`;

export const buttonContainer = css`
  margin-top: 1.5rem;
`;
